(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pavorniqa-page"]) return;
  try {
    
function setupPetDetails(){document.querySelectorAll('[data-pv-detail]').forEach(function(page){const gallery=page.querySelector('.pv-gallery');if(!gallery||page.dataset.ready)return;page.dataset.ready='true';const images=Array.from(gallery.querySelectorAll('img'));if(!images.length)return;page.classList.add('pv-detail-page');const layout=document.createElement('div');layout.className='pv-product';const media=document.createElement('div');media.className='pv-product-media';const main=images[0].cloneNode(true);main.loading='eager';media.append(main);const thumbs=document.createElement('div');thumbs.className='pv-thumbs';images.forEach(function(image,index){const button=document.createElement('button');button.type='button';button.setAttribute('aria-label','View image '+(index+1));button.setAttribute('aria-pressed',String(index===0));button.append(image.cloneNode(true));button.addEventListener('click',function(){main.src=image.src;main.alt=image.alt;thumbs.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));});thumbs.append(button);});media.append(thumbs);gallery.remove();const info=document.createElement('div');info.className='pv-product-info';while(page.firstChild)info.append(page.firstChild);const price=Array.from(info.querySelectorAll('p')).find(p=>p.textContent.includes('Proposed retail price'));if(price){price.classList.add('pv-product-price');const buying=document.createElement('div');buying.className='pv-buying';buying.innerHTML='<label>Quantity <input type="number" value="1" min="1" disabled aria-label="Quantity"></label><button type="button" class="pv-buy" disabled>Not available for purchase</button><p class="pv-note">Concept design. Availability has not been confirmed.</p>';price.after(buying);}layout.append(media,info);page.append(layout);});}setupPetDetails();document.addEventListener('shopify:section:load',setupPetDetails);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pavorniqa-product"]) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-pv-image]');if(!button)return;const gallery=button.closest('.pv-product-media');const main=gallery.querySelector(':scope > img');main.src=button.dataset.pvImage;main.alt=button.dataset.pvAlt||'';gallery.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));});

  } catch(e) { console.error(e); }
})();
})();
